import * as React from 'react'
import { Link } from '@amzn/dvui/dist/Link'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { TextLocalizer } from '../localizer/localizer'
import { roundValue } from '../../utils/numberUtils'
import * as styles from './amazonRating.module.scss'
import { safeBoolean } from '../../utils/utils'
import * as cn from 'classnames'
import { DpWidgetContext } from '../../utils/dpWidgetContext'

export interface IAmazonRatingBadgeProps {
  amazonRating?: WpsRuntime.atv.wps.AmazonRatingProps
  pageTitleId: string
  isRetail: boolean
  comingSoonMessagesPresent?: boolean
  isCerberusChild: boolean
}

//TODO(AVWebDP-648): Create new reftags for starlight review links
const createReviewLink = '/review/create-review/ref=acr_dpinstantvideo_solicit?ie=UTF8&asin='

interface FirstReviewProps {
  titleId: string,
  comingSoonMessagesPresent: boolean,
}

// Given that no reviews are currently present
const BeTheFirstToReview = ({ titleId, comingSoonMessagesPresent }: FirstReviewProps) => {
  if (comingSoonMessagesPresent) {
    return null
  }

  return <Link href={`${createReviewLink}${titleId}`}>
    <TextLocalizer stringID='DV_DP_first_review' />
  </Link>
}

export const AmazonRating = ({
                                        amazonRating,
                                        pageTitleId,
                                        isRetail,
                                        comingSoonMessagesPresent = false,
                                        isCerberusChild,
}: IAmazonRatingBadgeProps) => {
  const { getString } = React.useContext(DpWidgetContext)
  // We don't show Amazon Rating on Fogg
  if (!isRetail) {
    return null
  }
  const rating = amazonRating && amazonRating.value
  const count = amazonRating && amazonRating.count
  const countFormatted = amazonRating && amazonRating.countFormatted

  // We don't allow Child accounts or Win10 App users to see the First to Review link
  if (!count || !rating) {
    if (!safeBoolean(isCerberusChild) && !global.__NATIVEAPP__) {
      return <BeTheFirstToReview titleId={pageTitleId} comingSoonMessagesPresent={comingSoonMessagesPresent}/>
    }
    return null
  }

  const ariaLabel = getString('DV_DP_ARIA_amazon_rating', {
    ratingValue: roundValue(rating, 10).toString(),
    customerCount: count.toString()
  })

  const value = roundValue(rating, 2)
  const classes = [styles.one, styles.two, styles.three, styles.four]
  const hasHalfStar = Boolean((value * 2) % 2)
  const baseNumber = classes[Math.ceil(value) - 1]
  const automationId = 'customer-review-badge'

  // We disable the review section link for the Win10 App
  const linkWrapper = (content?: React.ReactNode) => global.__NATIVEAPP__ ?
    <span aria-label={ariaLabel} data-automation-id={automationId} role="img">
      {content}
    </span> :
    <a href={'#customer-review-section'} aria-label={ariaLabel} data-automation-id={automationId}>
      {content}
    </a>

  return linkWrapper(
    <>
      <Icon use={IconType.AMAZON_RATING}
            className={cn(styles.rating, baseNumber, {
                [styles.hasHalfStar]: hasHalfStar
              }
            )}/>
      <span>&nbsp;({countFormatted})</span>
    </>
  )
}
